import { ArrowDown, ArrowUp, Gauge, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { money, TECH } from "../lib/api";
import { useBuy } from "./BuyDialog";
import { useCountry } from "../context/CountryContext";

const BAND = { fibre: "from-[#F0326E] to-[#FF7A45]", "5g": "from-[#0FB5A5] to-[#22C55E]", lte: "from-[#FF9F1C] to-[#FFC23D]" };

export const PackageCard = ({ pkg, delay = 0, highlight = false }) => {
  const { buy } = useBuy();
  const { country } = useCountry();
  const uncapped = pkg.data_cap?.toLowerCase() === "uncapped";
  return (
    <div data-testid={`package-card-${pkg.id}`} style={{ animationDelay: `${delay}ms` }}
      className={`fade-up group relative flex flex-col overflow-hidden rounded-3xl border bg-white transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-primary/40 hover:shadow-[0_24px_48px_-24px_rgba(240,50,110,0.45)] ${highlight ? "ring-2 ring-primary" : ""}`}>
      <div className={`relative bg-gradient-to-r ${BAND[pkg.type]} px-6 pb-6 pt-5 text-white`}>
        <div className="flex items-center justify-between">
          <span className="rounded-full bg-white/25 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider backdrop-blur">{TECH[pkg.type]?.label}</span>
          {highlight && <span className="flex items-center gap-1 rounded-full bg-white px-2.5 py-0.5 text-[11px] font-bold text-primary"><Sparkles className="h-3 w-3" />Popular</span>}
        </div>
        <div className="mt-4 flex items-end gap-1.5" data-testid="package-speed-badge">
          <span className="font-display text-6xl font-black leading-none transition-transform duration-300 group-hover:scale-105">{pkg.download_mbps}</span>
          <span className="pb-1.5 text-sm font-bold opacity-90">Mbps</span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-center justify-between">
          <p className="font-semibold">{pkg.name}</p>
          <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${uncapped ? "bg-[#DDF7EE] text-[#0B7A6F]" : "bg-[#FFF3D6] text-[#9A6200]"}`}>{pkg.data_cap}</span>
        </div>
        <div className="mt-3 flex gap-4 font-mono-data text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><ArrowDown className="h-3.5 w-3.5" />{pkg.download_mbps}</span>
          <span className="flex items-center gap-1"><ArrowUp className="h-3.5 w-3.5" />{pkg.upload_mbps}</span>
          <span className="flex items-center gap-1"><Gauge className="h-3.5 w-3.5" />{pkg.network}</span>
        </div>
        <div className="mt-auto flex items-end justify-between pt-6">
          <div>
            <p className="font-display text-3xl font-extrabold" data-testid="package-price-text">{money(pkg.retail_price, country?.currency)}</p>
            <p className="text-xs text-muted-foreground" data-testid="package-setup-text">per month · {pkg.setup_fee > 0 ? `+ ${money(pkg.setup_fee, country?.currency)} once-off setup` : "free setup"}</p>
          </div>
          <Button className="rounded-full px-6 transition-transform hover:scale-105" data-testid={`package-order-btn-${pkg.id}`} onClick={() => buy({
            kind: "package", package_id: pkg.id, name: `${pkg.name} · ${TECH[pkg.type]?.label}`, price: pkg.retail_price + (pkg.setup_fee || 0), monthly: pkg.retail_price, setup_fee: pkg.setup_fee || 0, type: pkg.type,
          })}>Order now</Button>
        </div>
      </div>
    </div>
  );
};
